import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { registerSupplier } from "../modules/actions";
import { getBrands } from "../../Brendovi/modules/actions";

const mapStateToProps = (state) => ({
  supplierState: state.suppliersReducer,
  brands: state.brandReducer.brands,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      registerSupplier,
      getBrands,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
